import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { MAPPING_SITEID_TO_ACTIVATIONID } from './url-constants';

type MappingSitIdActivationIdEndpointSpecification = ApiEndpointSpecification;
export const MappingSitIdActivationIdEndpointSpecification: MappingSitIdActivationIdEndpointSpecification = {
    url: MAPPING_SITEID_TO_ACTIVATIONID,
    method: HttpMethod.PUT,
    requestParamsSchemaName: 'MappingSiteIdActivationIdRequestParams',
    requestBodySchemaName: 'MappingSiteIdActivationIdRequestBody',
    okResponseSchemaName: 'MappingSiteIdActivationIdOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeMappingSiteIdActivationId = Helpers.makeApiRequestFn<
    Types.MappingSiteIdActivationIdRequestParams,
    Types.MappingSiteIdActivationIdRequestBody,
    Types.MappingSiteIdActivationIdOkResponse
>(MappingSitIdActivationIdEndpointSpecification);
